export default class ViewHelpers
{
    public static setButtonEnabled(button: Element, enabled: boolean)
    {
        if (enabled)
        {
            button.classList.remove('loading');
            button.removeAttribute('disabled');
        }
        else
        {
            button.classList.add('loading');
            button.setAttribute('disabled', '');
        }
    }


    public static setFormEnabled(form: HTMLFormElement, enabled: boolean)
    {
        const formControls = form.querySelectorAll('input, textarea, button, select');

        for (let control of formControls)
        {
            if (!control.hasAttribute('data-no-auto-disable'))
            {
                if (enabled)
                {
                    control.removeAttribute('disabled');
                }
                else
                {
                    control.setAttribute('disabled', '');
                }
            }
        }

        const submitButtons =  form.querySelectorAll('[type="submit"]');

        for(let button of submitButtons)
        {
            if (enabled)
            {
                button.classList.remove('loading');
            }
            else
            {
                button.classList.add('loading');
            }
        }
    }
}